import React, { useEffect } from 'react';
import { useTable, useSortBy, useGlobalFilter, usePagination } from 'react-table';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faSearch } from '@fortawesome/free-solid-svg-icons';

export default function Table({ columns, data = [], rowsPerPage = 10 }) {

    const {
        getTableProps,
        getTableBodyProps,
        headerGroups,
        prepareRow,
        state,
        setGlobalFilter,
        page,
        canPreviousPage,
        canNextPage,
        pageOptions,
        nextPage,
        previousPage,
        setPageSize,
        state: { pageIndex }
    } = useTable(
        {
            columns,
            data,
            initialState: {
                pageSize: rowsPerPage === 0 ? data.length : rowsPerPage
            },
        },
        useGlobalFilter,
        useSortBy,
        usePagination,
    );

    useEffect(() => {
        if (data && data.length > 0) {
            if (rowsPerPage === 0) {
                setPageSize(data.length || 0);
            } else {
                setPageSize(rowsPerPage);
            }
        }
    }, [rowsPerPage, setPageSize, data, data.length]);

    return (
        <div>
            <div style={{position: 'relative', display: 'inline-block'}}>
                <FontAwesomeIcon
                    icon={faSearch}
                    style={{
                        position: 'absolute',
                        top: '40%',
                        left: '10px',
                        transform: 'translateY(-50%)',
                        color: '#aaa'
                    }}
                />
                <input
                    value={state.globalFilter || ''}
                    onChange={(e) => setGlobalFilter(e.target.value || undefined)}
                    placeholder="Search..."
                    style={{
                        marginBottom: '10px',
                        padding: '6px 6px 6px 30px',
                        fontSize: '14px',
                        width: '150px',
                    }}
                />
            </div>
            <div style={{overflowX: 'auto'}}>
                <table {...getTableProps()} style={{width: '100%', borderCollapse: 'collapse'}}>
                    <thead>
                    {headerGroups.map((headerGroup) => (
                        <tr {...headerGroup.getHeaderGroupProps()}>
                            {headerGroup.headers.map((column, index) => (
                                <th
                                    {...column.getHeaderProps(column.getSortByToggleProps())}
                                    style={{
                                        borderBottom: '2px solid #ddd',
                                        background: '#f2f2f2',
                                        padding: '8px',
                                        textAlign: 'left',
                                        cursor: column.canSort ? 'pointer' : 'default',
                                        borderRight: index < headerGroup.headers.length - 1 ? '1px solid #ddd' : 'none',
                                    }}
                                >
                                    {column.render('Header')}
                                    <span>
                                        {column.isSorted
                                            ? column.isSortedDesc
                                                ? ' 🔻'
                                                : ' 🔺'
                                            : ''}
                                    </span>
                                </th>
                            ))}
                        </tr>
                    ))}
                    </thead>
                    <tbody {...getTableBodyProps()}>
                    {page.length === 0 ? (
                        <tr>
                            <td colSpan={columns.length} style={{ textAlign: 'center', padding: '20px' }}>
                                No data available
                            </td>
                        </tr>
                    ) : (
                        page.map((row) => {
                            prepareRow(row);
                            return (
                                <tr
                                    {...row.getRowProps()}
                                    style={{
                                        transition: 'background-color 0.3s',
                                        cursor: 'pointer',
                                        backgroundColor: '#fff',
                                    }}
                                    onMouseEnter={(e) => e.currentTarget.style.backgroundColor = '#eff6ff'}
                                    onMouseLeave={(e) => e.currentTarget.style.backgroundColor = '#fff'}
                                >
                                    {row.cells.map((cell) => (
                                        <td
                                            {...cell.getCellProps()}
                                            style={{
                                                padding: '8px',
                                                borderBottom: '1px solid #ddd',
                                            }}
                                        >
                                            {cell.render('Cell')}
                                        </td>
                                    ))}
                                </tr>
                            );
                        })
                    )}
                    </tbody>
                </table>
            </div>
            {rowsPerPage !== 0 && (
                <div style={{
                    marginTop: '10px',
                    display: 'flex',
                    justifyContent: 'space-between',
                    alignItems: 'center'
                }}>
                <span>
                    Page {pageIndex + 1} of {pageOptions.length}
                </span>
                    <div>
                        <button
                            onClick={() => previousPage()}
                            disabled={!canPreviousPage}
                            style={{
                                backgroundColor: '#263BA9',
                                color: '#fff',
                                border: '1px solid #263BA',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                marginRight: '5px',
                                cursor: canPreviousPage ? 'pointer' : 'not-allowed',
                                fontSize: '14px',
                                transition: 'background-color 0.3s, border-color 0.3s',
                            }}
                        >
                            Previous
                        </button>
                        <button
                            onClick={() => nextPage()}
                            disabled={!canNextPage}
                            style={{
                                backgroundColor: '#263BA9',
                                color: '#fff',
                                border: '1px solid #263BA',
                                borderRadius: '4px',
                                padding: '6px 12px',
                                cursor: canNextPage ? 'pointer' : 'not-allowed',
                                fontSize: '14px',
                                transition: 'background-color 0.3s, border-color 0.3s',
                            }}
                        >
                            Next
                        </button>
                    </div>
                </div>
            )}
        </div>
    );
}
